export default __webpack_public_path__ + "static/media/404.284d3ac7.png";